import { Components } from '@mui/material/styles'

export const MuiAccordionSummary: Components['MuiAccordionSummary'] = {
  styleOverrides: {
    root: {
      padding: '8px 0',
      margin: '0 0 8px',
      minHeight: '0',
      '&.Mui-expanded': {
        minHeight: '0',
      },
    },
    content: {
      margin: '0',
      fontSize: '14px',
      fontWeight: 700,
      '&.Mui-expanded': {
        margin: '0',
        minHeight: '0',
      },
    },
  },
}
